import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {

  private storageKey = 'action_token';

  setToken(token: string) {
    sessionStorage.setItem(this.storageKey, token);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.storageKey);
  }

  clear() {
    sessionStorage.removeItem(this.storageKey);
  }
}